export default __webpack_public_path__ + "static/media/QuarterPipe_Corner_01.256.4cf00449.png";